import { gql } from 'graphql-tag'

import ProductTileFragment from '@Queries/cms/fragments/ProductTile.fragment'

export default gql`
  ${ProductTileFragment}

  fragment TacticRecommendationsFragment on IWithRecommendations {
    recommendations @include(if: $loadRecommendations) {
      id
      title
      type
      placement
      products(mode: PROJECTION, onlyAvailable: true, onlyEnabled: true) {
        ...ProductTileFragment
      }
    }
  }
`
